"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Subcontact = require("./Subcontact");
Object.keys(_Subcontact).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Subcontact[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Subcontact[key];
    }
  });
});